import ContentsTypes from "@shared/enums/contentsTypes";
import ModulesOutilsTemplate from "@project/templates/modules-outils/ModulesOutilsTemplate";
import customTypes from "@project/enums/contentsCustomTypes.enum";
import { createRowButtonItem } from "@project/templates/home/home";
import { createPricingCardItem } from "@project/templates/pricingCardItem";
import { createButton } from "@project/templates/buttonWithArrow";
import { createIllustrationTabs } from "@project/templates/illustrationTabItem";
import { createStepsItem } from "@project/templates/stepsItem";
export default {
    key: "MODULES_OUTILS",
    label: "Modules outils",
    shortDescription: "Des modules cyber complémentaires pour adapter votre protection à vos risques prioritaires.",
    templateImage: "/template-modules-outils.png",
    Component: ModulesOutilsTemplate,
    initialContents: [
        {
            key: "title",
            type: ContentsTypes.TEXT,
            value: "%3Ch1%3E%3Cspan%20style%3D%22color%3Ahsl(0%2C%200%25%2C%20100%25)%3B%22%3ERenforcez%20votre%20%3Cstrong%3Eprotection%20cyber%3C%2Fstrong%3E%20avec%20les%20modules%20adapt%C3%A9s%20%C3%A0%20vos%20priorit%C3%A9s%3C%2Fspan%3E%3C%2Fh1%3E",
        },
        {
            key: "shortDescription",
            type: ContentsTypes.TEXT,
            value: "%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%3Cspan%20style%3D%22color%3Ahsl(0%2C%200%25%2C%20100%25)%3Bfont-size%3A16px%3B%22%3ELes%20modules%20outils%20Cyber%20Docaposte%20vous%20permettent%20de%20construire%20ou%20compl%C3%A9ter%20votre%20protection%20selon%20vos%20besoins%20%3A%20supervision%20des%20postes%2C%20sauvegarde%2C%20mots%20de%20passe%2C%20messagerie%2C%20navigation%20internet%20et%20applications%20web.%3C%2Fspan%3E%3C%2Fp%3E",
        },
        {
            key: "presentationDynamic",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "ROW",
                    value: "",
                    children: [
                        createRowButtonItem("Obtenir une estimation personnalisée", "contained"),
                        createRowButtonItem("Identifier les modules adaptés", "outlined"),
                        {
                            key: "justifyContent",
                            type: ContentsTypes.SELECT,
                            value: "flex-start",
                        },
                        { key: "spacing", type: "SLIDER", value: "24" },
                        { key: "columnOnMobile", type: "CHECKBOX", value: "true" },
                        { key: "useFlexWrap", type: "CHECKBOX", value: "true" },
                    ],
                },
            ],
        },
        {
            key: "offerPresentationCard",
            type: customTypes.OFFER_PRESENTATION_CARD,
            value: "",
            children: [
                {
                    key: "barColor",
                    type: ContentsTypes.COLOR,
                    value: "#BF7CFF",
                },
                {
                    key: "surtitle",
                    type: ContentsTypes.INPUT,
                    value: "Les modules outils",
                },
                {
                    key: "isPriceCard",
                    type: ContentsTypes.CHECKBOX,
                    value: "false",
                },
                {
                    key: "title",
                    type: ContentsTypes.INPUT,
                    value: "6 protections activables",
                },
                {
                    key: "titleComplement",
                    type: ContentsTypes.INPUT,
                    value: "",
                },
                {
                    key: "titleFeatures",
                    type: ContentsTypes.INPUT,
                    value: "Composez selon vos besoins",
                },
                {
                    key: "features",
                    type: ContentsTypes.TEXT,
                    value: "<ul><li>Protection des postes de travail</li><li>Sauvegarde sécurisée</li><li>Gestionnaire de mots de passe</li><li>Protection de la messagerie</li><li>Filtrage de navigation</li><li>Protection des applications web / WAF</li></ul>",
                },
                {
                    key: "featuresOptional",
                    type: ContentsTypes.CHECKBOX,
                    value: "true",
                },
                {
                    key: "plusFeature",
                    type: ContentsTypes.INPUT,
                    value: "Acces a mon espace client cyber",
                },
                {
                    key: "plusFeatureIcon",
                    type: ContentsTypes.ICON,
                    value: "",
                    children: [
                        { key: "icon", type: ContentsTypes.INPUT, value: "desktop" },
                        { key: "type", type: ContentsTypes.SELECT, value: "far" },
                        { key: "color", type: ContentsTypes.COLOR, value: "#0000FF" },
                        { key: "background", type: ContentsTypes.COLOR, value: "" },
                    ],
                },
            ],
        },
        {
            key: "surtitleOfferTargetPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Une approche modulaire",
        },
        {
            key: "titleOfferTargetPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Compléter ou construire votre protection cyber, selon vos priorités",
        },
        {
            key: "descriptionOfferTargetPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Que votre cybersécurité soit à construire ou à compléter, les modules Cyber vous aident à identifier les protections utiles, ajuster le périmètre et piloter les solutions retenues avec plus de lisibilité.",
        },
        {
            key: "targetDynamic",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [],
        },
        {
            key: "infosBlock",
            type: customTypes.INFOS_BLOCK,
            value: "",
            children: [
                {
                    key: "title",
                    type: ContentsTypes.INPUT,
                    value: "Ces modules sont adaptés à vos besoins si",
                },
                {
                    key: "items",
                    type: ContentsTypes.TEXT,
                    value: "<ul><li>Compléter un dispositif existant et avancer progressivement, sans remplacer vos solutions en place ni suréquipement inutile</li><li>Prioriser les protections selon vos risques : postes, données, messagerie, accès, navigation ou applications web</li><li>Avancer progressivement, sans suréquipement ni complexité inutile </li></ul>",
                },
            ],
        },
        {
            key: "titleProtectionsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Identifier vos besoins",
        },
        {
            key: "subtitleProtectionsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Identifier les protections adaptées à vos besoins",
        },
        {
            key: "descriptionProtectionsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Les modules outils réunissent six protections complémentaires. Ouvrez chaque module pour comprendre le risque, la réponse Docaposte et le bénéfice pour votre organisation.",
        },
        {
            key: "dynamicProtectionsPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                createIllustrationTabs("horizontal", [
                    {
                        label: "Protection des postes de travail",
                        description: "Une défense proactive combinant détection logicielle et supervision continue pour neutraliser les menaces avant qu'elles n'impactent votre activité.",
                        borderColor: "#0CFFC6",
                        sections: [
                            {
                                label: "Le risque",
                                text: "Un logiciel malveillant, une intrusion ou une activité suspecte peut compromettre un poste et se propager dans l'environnement numérique.",
                            },
                            {
                                label: "La réponse Docaposte",
                                text: "Notre protection supervisée combine détection logicielle, surveillance continue et qualification des alertes par un service spécialisé.",
                            },
                            {
                                label: "Votre bénéfice",
                                text: "Vous limitez les risques d'interruption, de propagation et de perte de données, sans recruter d'expertise cyber en interne.",
                            },
                        ],
                    },
                    {
                        label: "Sauvegarde sécurisée",
                        description: "Une solution de sauvegarde automatique et sécurisée pour préserver les données critiques et faciliter la reprise en cas d'incident.",
                        borderColor: "#BF7CFF",
                        sections: [
                            {
                                label: "Le risque",
                                text: "Une erreur humaine, une panne, un sinistre ou une attaque peut rendre des données essentielles indisponibles, inutilisables ou chiffrées",
                            },
                            {
                                label: "La réponse Docaposte",
                                text: "Notre sauvegarde sécurisée permet de conserver les données importantes, de les protéger et de les restaurer en cas d’incident. ",
                            },
                            {
                                label: "Votre bénéfice",
                                text: "Vos équipes adoptent de meilleurs réflexes, gagnent du temps et réduisent les risques de compromission de compte. ",
                            },
                        ],
                    },
                    {
                        label: "Gestionnaire de mots de passe",
                        description: "Un coffre-fort numérique pour générer, stocker, organiser et partager des mots de passe robustes de manière sécurisée.",
                        borderColor: "#FFFF80",
                        sections: [
                            {
                                label: "Le risque",
                                text: "Des mots de passe faibles, réutilisés ou partagés par des canaux non sécurisés exposent les comptes et applications de l'organisation.",
                            },
                            {
                                label: "La réponse Docaposte",
                                text: "Docaposte propose un gestionnaire de mots de passe : génération robuste, coffre-fort sécurisé, partage sécurisé, plugin navigateur, accès multi-appareils et authentification multi-facteurs. ",
                            },
                            {
                                label: "Votre bénéfice",
                                text: "Vos équipes sécurisent leurs accès tout en gagnant en simplicité : remplissage automatique, stockage centralisé et réduction des pratiques à risque. ",
                            },
                        ],
                    },
                    {
                        label: "Protection de la messagerie",
                        description: "Un filtre intelligent pour bloquer spams, emails frauduleux et contenus malveillants avant qu'ils n'atteignent les collaborateurs.",
                        borderColor: "#FF5657",
                        sections: [
                            {
                                label: "Le risque",
                                text: "La messagerie est un vecteur majeur d'attaque : phishing, fraude au président, pièces jointes piégées ou usurpation d'identité.",
                            },
                            {
                                label: "La réponse Docaposte",
                                text: "Docaposte installe une protection en amont de la messagerie existante : analyse des liens, pièces jointes, réputation des expéditeurs et mise en quarantaine.",
                            },
                            {
                                label: "Votre bénéfice",
                                text: "Vous réduisez l'exposition des collaborateurs aux emails piégés et améliorez l'hygiène cyber des échanges quotidiens..",
                            },
                        ],
                    },
                    {
                        label: "Filtrage de navigation ",
                        description: "Une solution pour bloquer l’accès aux sites internet dangereux, frauduleux ou non autorisés, au bureau comme en mobilité. ",
                        borderColor: "#006BD4",
                        sections: [
                            {
                                label: "Le risque",
                                text: "Un collaborateur peut être exposé à un site infecté, à une page frauduleuse, à un téléchargement malveillant ou à un lien de phishing web, y compris en télétravail. ",
                            },
                            {
                                label: "La réponse Docaposte",
                                text: "Docaposte propose une protection de navigation fondée sur le filtrage web / DNS, l’analyse des domaines et la mise à jour continue des listes de menaces, avec paramétrage des règles selon les usages. ",
                            },
                            {
                                label: "Votre bénéfice",
                                text: "Vous réduisez les risques liés aux malwares et au phishing web, renforcez le contrôle des usages Internet et sécurisez l’accès au web sans gêner l’activité quotidienne. \nInformations utiles \nLes règles de navigation sont définies selon vos usages. Elles peuvent être adaptées selon les profils d’utilisateurs et les besoins de votre organisation. ",
                            },
                        ],
                    },
                    {
                        label: "Protection des applications web / WAF ",
                        description: "Une barrière de protection entre vos applications web et Internet pour filtrer, surveiller et bloquer les attaques malveillantes. ",
                        borderColor: "#DCE8FF",
                        sections: [
                            {
                                label: "Le risque",
                                text: "Les sites, applications web et API exposés sur Internet peuvent subir des attaques web, tentatives d’injection, défacement, exploitation de vulnérabilités, robots malveillants ou dénis de service. ",
                            },
                            {
                                label: "La réponse Docaposte",
                                text: "La protection des applications web se positionne en amont des applications à protéger. Elle filtre et surveille le trafic avec des modules de sécurité adaptés : protection des API, réputation d’adresse IP, restriction géographique et paramétrage du niveau de sécurité. ",
                            },
                            {
                                label: "Votre bénéfice",
                                text: "Vous réduisez l’exposition des services web aux attaques, bloquez le trafic malveillant et disposez d’une protection adaptée aux applications et API critiques. \nInformations utiles \nLes règles de navigation sont définies selon vos usages. Elles peuvent être adaptées selon les profils d’utilisateurs et les besoins de votre organisation.",
                            },
                        ],
                    },
                ]),
            ],
        },
        {
            key: "titleInterfacePart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Interface unifiée",
        },
        {
            key: "subtitleInterfacePart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "L'Espace client : votre centre de contrôle cyber",
        },
        {
            key: "descriptionInterfacePart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "L'espace client Docaposte centralise les informations utiles pour suivre les services activés, accéder aux ressources disponibles et faciliter les échanges avec le support.",
        },
        {
            key: "imageInterfacePart",
            type: "IMAGE_BLOCK",
            value: "",
            children: [
                {
                    key: "image",
                    type: ContentsTypes.IMAGE,
                    value: "",
                    children: [
                        {
                            key: "file",
                            type: ContentsTypes.FILE_IMAGE,
                            value: JSON.stringify({
                                id: "",
                                name: "",
                                mimeType: "image/webp",
                                publicUrl: `/api/medias/""`,
                                url: `/api/medias/""`,
                                alt: "image",
                                title: "image",
                            }),
                        },
                        { key: "alt", type: ContentsTypes.INPUT, value: "image" },
                        { key: "title", type: ContentsTypes.INPUT, value: "image" },
                        {
                            key: "position_verticale",
                            type: ContentsTypes.SELECT,
                            value: "top",
                        },
                        {
                            key: "position_horizontale",
                            type: ContentsTypes.SELECT,
                            value: "center",
                        },
                        {
                            key: "position_ajustement",
                            type: ContentsTypes.SELECT,
                            value: "cover",
                        },
                    ],
                },
                { key: "width", type: "SLIDER", value: "100" },
                { key: "mobileWidth", type: "SLIDER", value: "100" },
                { key: "justifyContent", type: "SELECT", value: "flex-start" },
            ],
        },
        {
            key: "interfaceFeaturestList",
            type: customTypes.LIST_INFOS,
            value: "",
            children: [
                {
                    key: "dynamicList",
                    type: ContentsTypes.DYNAMIC_LIST,
                    value: "",
                    children: [
                        {
                            key: "contentType",
                            value: customTypes.LIST_INFOS_ITEM,
                            children: [
                                {
                                    key: "items",
                                    type: customTypes.LIST_INFOS_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Protection supervisée des postes",
                                        },
                                        {
                                            key: "description",
                                            type: ContentsTypes.INPUT,
                                            value: "Suivi en temps réel des alertes de sécurité.",
                                        },
                                    ],
                                },
                                {
                                    key: "items",
                                    type: customTypes.LIST_INFOS_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Sauvegarde sécurisée",
                                        },
                                        {
                                            key: "description",
                                            type: ContentsTypes.INPUT,
                                            value: "Historique et état de vos sauvegardes critiques.",
                                        },
                                    ],
                                },
                                {
                                    key: "items",
                                    type: customTypes.LIST_INFOS_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Configuration",
                                        },
                                        {
                                            key: "description",
                                            type: ContentsTypes.INPUT,
                                            value: "Déploiement rapide de vos solutions de cybersécurité.",
                                        },
                                    ],
                                },
                                {
                                    key: "items",
                                    type: customTypes.LIST_INFOS_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Ressources",
                                        },
                                        {
                                            key: "description",
                                            type: ContentsTypes.INPUT,
                                            value: "Guides, bonnes pratiques et documentations techniques.",
                                        },
                                    ],
                                },
                                {
                                    key: "items",
                                    type: customTypes.LIST_INFOS_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Support Docaposte basé en France",
                                        },
                                        {
                                            key: "description",
                                            type: ContentsTypes.INPUT,
                                            value: "Une assistance humaine disponible en cas de besoin.",
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "titleSetupPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Étapes de mise en place",
        },
        {
            key: "subtitleSetupPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Vous êtes accompagné dans le choix et la mise en service de vos modules ",
        },
        {
            key: "descriptionSetupPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Après qualification de votre besoin, Docaposte vous accompagne pour préciser le périmètre à protéger, confirmer les informations nécessaires et organiser la mise en service des modules retenus. ",
        },
        {
            key: "dynamicSetupPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                createStepsItem([
                    {
                        title: "Qualifier",
                        description: "Docaposte échange avec vous pour comprendre vos enjeux, vos risques prioritaires et les protections déjà en place.",
                        borderColor: "#BF7CFF",
                    },
                    {
                        title: "Composer",
                        description: "Les modules utiles sont identifiés selon votre contexte : postes, données, accès, messagerie, navigation ou applications web.",
                        borderColor: "#0CFFC6",
                    },
                    {
                        title: "Mise en service",
                        description: "Vous êtes accompagné dans l'installation, le paramétrage et la prise en main des modules retenus.",
                        borderColor: "#FFFF80",
                    },
                    {
                        title: "Lancement de la protection",
                        description: "Votre Pack Cyber est opérationnel : protections activées, ressources pour faciliter la prise en main et accès au support Docaposte en cas de besoin.",
                        borderColor: "#BF7CFF",
                    },
                ]),
            ],
        },
        {
            key: "labelDynamic",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "GRID",
                    value: "",
                    children: [
                        {
                            key: "items",
                            type: customTypes.CARD_LABEL,
                            value: "",
                            children: [
                                {
                                    key: "title",
                                    type: ContentsTypes.INPUT,
                                    value: "Docaposte, filiale du Groupe La Poste",
                                },
                                {
                                    key: "description",
                                    type: ContentsTypes.SHORT_TEXT,
                                    value: "Un acteur français de confiance, ancré dans l’écosystème de la confiance numérique",
                                },
                                {
                                    key: "alignment",
                                    type: ContentsTypes.SELECT,
                                    value: "center",
                                },
                            ],
                        },
                        {
                            key: "items",
                            type: customTypes.CARD_LABEL,
                            value: "",
                            children: [
                                {
                                    key: "title",
                                    type: ContentsTypes.INPUT,
                                    value: "EDR partenaire reconnu ANSSI / BSI",
                                },
                                {
                                    key: "description",
                                    type: ContentsTypes.SHORT_TEXT,
                                    value: "Premier EDR qualifié en France et seul avec double certification ANSSI / BSI",
                                },
                                {
                                    key: "alignment",
                                    type: ContentsTypes.SELECT,
                                    value: "center",
                                },
                            ],
                        },
                        {
                            key: "items",
                            type: customTypes.CARD_LABEL,
                            value: "",
                            children: [
                                {
                                    key: "title",
                                    type: ContentsTypes.INPUT,
                                    value: "Souveraineté et hébergement en France",
                                },
                                {
                                    key: "description",
                                    type: ContentsTypes.SHORT_TEXT,
                                    value: "Données et services opérés dans un cadre de confiance, hébergés en France",
                                },
                                {
                                    key: "icon",
                                    type: ContentsTypes.ICON,
                                    value: "",
                                    children: [
                                        {
                                            key: "icon",
                                            type: ContentsTypes.INPUT,
                                            value: "souverainete",
                                        },
                                        {
                                            key: "type",
                                            type: ContentsTypes.SELECT,
                                            value: "custom",
                                        },
                                        {
                                            key: "color",
                                            type: ContentsTypes.COLOR,
                                            value: "#0000FF",
                                        },
                                        {
                                            key: "background",
                                            type: ContentsTypes.COLOR,
                                            value: "",
                                        },
                                    ],
                                },
                                {
                                    key: "alignment",
                                    type: ContentsTypes.SELECT,
                                    value: "center",
                                },
                            ],
                        },
                        {
                            key: "items",
                            type: customTypes.CARD_LABEL,
                            value: "",
                            children: [
                                {
                                    key: "title",
                                    type: ContentsTypes.INPUT,
                                    value: "Accompagnement Docaposte",
                                },
                                {
                                    key: "description",
                                    type: ContentsTypes.SHORT_TEXT,
                                    value: "Une relation client centralisée pour faciliter la mise en service, le suivi et le support.",
                                },
                                {
                                    key: "icon",
                                    type: ContentsTypes.ICON,
                                    value: "",
                                    children: [
                                        {
                                            key: "icon",
                                            type: ContentsTypes.INPUT,
                                            value: "relation_collaborateur",
                                        },
                                        {
                                            key: "type",
                                            type: ContentsTypes.SELECT,
                                            value: "custom",
                                        },
                                        {
                                            key: "color",
                                            type: ContentsTypes.COLOR,
                                            value: "#0000FF",
                                        },
                                        {
                                            key: "background",
                                            type: ContentsTypes.COLOR,
                                            value: "",
                                        },
                                    ],
                                },
                                {
                                    key: "alignment",
                                    type: ContentsTypes.SELECT,
                                    value: "center",
                                },
                            ],
                        },
                        { key: "size", type: "SELECT_GRID", value: "3" },
                        { key: "sizeSm", type: "SELECT_GRID", value: "6" },
                        { key: "sizeXs", type: "SELECT_GRID", value: "12" },
                        { key: "justify", type: "SELECT", value: "center" },
                        { key: "alignItems", type: "SELECT", value: "stretch" },
                        { key: "spacing", type: "SLIDER", value: "24" },
                        { key: "mobileSpacing", type: "SLIDER", value: "16" },
                    ],
                },
            ],
        },
        {
            key: "titleContactPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Construisons ensemble la protection cyber adaptée à vos priorités",
        },
        {
            key: "descriptionContactPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Un expert Docaposte vous accompagne pour définir les protections prioritaires, préciser le périmètre à couvrir et organiser la mise en service des modules retenus.",
        },
        {
            key: "dynamicContactPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [createButton("Construire ma protection cyber", "contact")],
        },
        {
            key: "titleFurtherPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Aller plus loin",
        },
        {
            key: "subtitleFurtherPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Poursuivez votre parcours selon votre besoin",
        },
        {
            key: "dynamicFurtherPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "GRID",
                    value: "",
                    children: [
                        createPricingCardItem("default", "M", "#0CFFC6", "TPE, petites PME", "Découvrir le Pack Cyber", "Pour mettre en place un premier socle de protection clair et accompagné.", "", "", "", "", "", "", "/Pack-cyber", "Découvrir", "long-arrow-right"),
                        createPricingCardItem("default", "M", "#FFFF80", "ETI, grande collectivités, organisation mature", "Découvrir les prestations expertes", "Pour compléter votre protection avec un accompagnement expert sur mesure.", "", "", "", "", "", "", "/prestation-expertes", "Découvrir", "long-arrow-right"),
                        createPricingCardItem("highlighted", "M", "#0000FF", "", "Revenir à l'accueil de l'offre Cyber", "Pour retrouver une vue d'ensemble de nos solutions cyber.", "", "", "", "", "", "", "/", "Revenir", "long-arrow-right"),
                        { key: "size", type: "SELECT_GRID", value: "4" },
                        { key: "sizeSm", type: "SELECT_GRID", value: "12" },
                        { key: "sizeXs", type: "SELECT_GRID", value: "12" },
                        { key: "justify", type: "SELECT", value: "center" },
                        { key: "alignItems", type: "SELECT", value: "stretch" },
                        { key: "spacing", type: "SLIDER", value: "48" },
                        { key: "mobileSpacing", type: "SLIDER", value: "16" },
                    ],
                },
            ],
        },
    ],
};
